var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{staticClass:"returnBtn",attrs:{"to":_vm.path}},[_vm._v(" 一覧に戻る ")])
}
var staticRenderFns = []

export { render, staticRenderFns }